export default __webpack_public_path__ + "static/bavaria-ded6381229890faa1f5c05c3d73df77a.jpg";